import { Document } from "@contentful/rich-text-types";
import Text from "myplan/components//Text";
import Button from "myplan/components/Button";
import { PhoneIcon, SmsIcon, WebsiteIcon } from "myplan/components/Icon";
import RichText, { InlineRichText } from "myplan/components/RichText";
import { useOpenUrl, UrlType } from "myplan/utils/url";
import React, { Component } from "react";
import { TextStyle, ViewStyle } from "react-native";
import { TouchableOpacity } from "react-native";
import {
    Aside,
    Body,
    BodyRichContainer,
    Container,
    DefaultTitle,
    Destination,
    Image,
    Main,
    Spacer,
    Title,
} from "./styles";

export enum SnippetType {
    Default = "DEFAULT",
    Strategy = "STRATEGY",
    Resource = "RESOURCE",
    KnowledgeTestResult = "KNOWLEDGE_TEST_RESULT",
    Reverse = "REVERSE",
}

const renderDefault = (
    body,
    bodyRich,
    imageUrl,
    isOdd,
    destination,
    title,
    titleRich,
) => {
    const theTitle = titleRich ? <InlineRichText doc={titleRich} /> : title;
    return (
        <Container imageUrl={imageUrl} isOdd={isOdd}>
            <Aside isOdd={isOdd}>
                {imageUrl && (
                    <Image
                        source={{ uri: imageUrl, width: 170 }}
                        resizeMode="contain"
                    />
                )}
            </Aside>

            <Main>
                {theTitle && (
                    <DefaultTitle
                        type="h1"
                        imageUrl={imageUrl}
                        isOdd={isOdd}
                        destination={destination}>
                        {theTitle}
                    </DefaultTitle>
                )}
                {bodyRich ? (
                    <BodyRichContainer
                        imageUrl={imageUrl}
                        isOdd={isOdd}
                        destination={destination}>
                        <RichText doc={bodyRich} />
                    </BodyRichContainer>
                ) : (
                    <Body
                        imageUrl={imageUrl}
                        isOdd={isOdd}
                        destination={destination}>
                        {body}
                    </Body>
                )}

                {destination && (
                    <Destination imageUrl={imageUrl} isOdd={isOdd}>
                        <Button
                            title={destination.title}
                            onPress={destination.onPress}
                            containerStyle={{
                                paddingHorizontal: 12,
                            }}
                        />
                    </Destination>
                )}
            </Main>
            {!imageUrl && <Spacer />}
        </Container>
    );
};

const renderCta = (type, title, resource, iconStyle?, containerStyle?) => {
    const openUrl = useOpenUrl();
    let Icon;
    let _iconStyle: TextStyle = {
        color: "#E86451",
    };
    let _type = type;

    if (iconStyle) {
        _iconStyle = {
            _iconStyle,
            ...iconStyle,
        };
    }

    switch (type) {
        case UrlType.Phone:
            Icon = PhoneIcon;
            break;

        case UrlType.Sms:
            Icon = SmsIcon;
            break;

        case UrlType.Url:
            _type = UrlType.Website;
            Icon = WebsiteIcon;
            break;
    }

    return (
        <TouchableOpacity onPress={() => openUrl(_type, resource)}>
            <Container style={containerStyle}>
                <Aside>
                    <Icon
                        width="30"
                        height="30"
                        color={_iconStyle.color}
                        style={_iconStyle}
                    />
                </Aside>
                <Main>
                    <Text type="mono3">{title}</Text>
                    <Text>{resource.title}</Text>
                </Main>
                <Spacer />
            </Container>
        </TouchableOpacity>
    );
};

const renderKnowledgeTestResult = (title, titleRich, body, bodyRich, Icon) => {
    const theTitle = titleRich ? <InlineRichText doc={titleRich} /> : title;
    return (
        <Container isKnowledgeTest>
            {Icon && (
                <Aside isKnowledgeTest>
                    <Icon width="36" height="36" />
                </Aside>
            )}
            <Main>
                <Title type="h8" isKnowledgeTest>
                    {theTitle}
                </Title>

                {bodyRich ? (
                    <BodyRichContainer>
                        <RichText doc={bodyRich} />
                    </BodyRichContainer>
                ) : (
                    <Body>{body}</Body>
                )}
            </Main>
        </Container>
    );
};

export interface SnippetCtaDestination {
    title: string;
    onPress?: () => void;
}

type SnippetProps = {
    type?: SnippetType;
    title?: string;
    titleRich?: Document;
    body?: string;
    bodyRich?: Document;
    payload?: any;
    imageUrl?: string | null;
    strategy?: any;
    resource?: any;
    resourceCtaType?: "PHONE" | "SMS";
    resourceCtaTitle?: string;
    Icon?: Component;
    iconStyle?: TextStyle;
    containerStyle?: ViewStyle;
    destination?: SnippetCtaDestination | null;
    isOdd?: boolean;
    index?: number;
};

const Snippet = ({
    type = SnippetType.Default,
    title,
    titleRich,
    body,
    bodyRich,
    payload,
    imageUrl,
    strategy,
    resource,
    Icon,
    iconStyle,
    containerStyle,
    resourceCtaType,
    resourceCtaTitle,
    destination,
    isOdd,
}: SnippetProps) => {
    let result;

    // test if body is string
    // if string, wrap in BodyText
    // else pass in

    switch (type) {
        case SnippetType.Default: {
            result = renderDefault(
                body,
                bodyRich,
                imageUrl,
                isOdd,
                destination,
                title,
                titleRich,
            );
            break;
        }

        // case SnippetType.Strategy:
        case SnippetType.Resource:
            result = renderCta(
                resourceCtaType,
                resourceCtaTitle,
                resource,
                iconStyle,
                containerStyle,
            );
            break;

        case SnippetType.KnowledgeTestResult:
            result = renderKnowledgeTestResult(
                title,
                titleRich,
                body,
                bodyRich,
                Icon,
            );
            break;
    }

    return result;
};

export default Snippet;
